export const CONSENT_COOKIE_NAME = "adp_consent_v1" as const;

export type ConsentDecision = "granted" | "declined";

/**
 * Returns the parsed decision, or null when the cookie is absent / malformed.
 * Treat null as "no decision yet" — render the banner.
 */
export function parseConsentCookie(value: string | undefined): ConsentDecision | null {
  if (value === "granted" || value === "declined") {
    return value;
  }
  return null;
}

/**
 * Build a Set-Cookie attribute string. Host-only (no Domain), 1-year Max-Age,
 * SameSite=Lax. Secure attribute is gated by the caller because local dev runs
 * on http://localhost where Secure would block the cookie.
 */
export function serializeConsentCookie(
  decision: ConsentDecision,
  opts: { secure: boolean },
): string {
  const parts = [
    `${CONSENT_COOKIE_NAME}=${decision}`,
    "Path=/",
    "Max-Age=31536000",
    "SameSite=Lax",
  ];
  if (opts.secure) {
    parts.push("Secure");
  }
  return parts.join("; ");
}
